import { GridEventListener } from '@mui/x-data-grid-pro';

/**
 * @deprecated We move this function to editEventHelpers
 */
export const handleCellFocusOut: GridEventListener<'cellFocusOut'> = (_params, event) => {
    event.defaultMuiPrevented = true;
};
